import { Component, EventEmitter, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil, startWith, filter, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';


@Component({
    selector: 'formly-field-typeahead',
    template: `

    <div class="form-group">
    <label >{{to?.label || ""}}</label>
    
    <ng-select
        [items]="to.options|formlySelectOptions:field|async"

        [items]="options$ | async"
        [placeholder]="to.placeholder"
        [typeahead]="search$"
        [bindLabel]="to.labelProp"
        [bindValue]="to.valueProp"
        [multiple]="to.multiple"
        [formControl]="formControl">
    </ng-select>
    </div>
  `,
})
export class FormlyFieldTypeahead extends FieldType implements OnDestroy {
    onDestroy$ = new Subject<void>();
    search$ = new EventEmitter();

    options$;

    ngOnInit() {
        this.options$ = this.search$.pipe(
            takeUntil(this.onDestroy$),
            startWith(''),
            filter(v => v !== null),
            debounceTime(200),
            // distinctUntilChanged(),
            switchMap(this.to.search$),

        );

        this.options$.subscribe();
    }

    ngOnDestroy() {
        this.onDestroy$.complete();
    }
}
